//=require blueimp-file-upload/js/jquery.fileupload.js
//=require jquery.cookie/jquery.cookie.js
//=require js/jquery.form.min.js
//=require typeahead.js/dist/typeahead.bundle.min.js
//=require alpha/src/jvzoo/affiliate_referral_calculation.js
//=require alpha/src/custom_controls/jvz-form-behavior.js
//=require moment/moment.js
//=require flatpickr/dist/flatpickr.min.js
//=require bootstrap-select/dist/js/bootstrap-select.min.js
//=require flatpickr/dist/plugins/monthSelect/index.js


//=require card-validator/src/lib/is-array.js
//=require card-validator/src/postal-code.js
//=require card-validator/src/card-number.js
//=require card-validator/src/cvv.js
//=require card-validator/src/expiration-date.js
//=require card-validator/src/expiration-month.js
//=require card-validator/src/expiration-year.js
//=require card-validator/src/luhn-10.js
//=require card-validator/src/parse-date.js
//=require card-validator/src/postal-code.js